function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DefaultPropTypes from "../utils/prop-types";
import MimeType from "../utils/mime-type";
import { trackDownloadInResourceCenter } from "../../../../js/feature/gtm-tracking";
import setupErrorMsg from "../../../../js/feature/cookie-consent-error";
import Loader from "../../../../js/project/loader-react";
var ItemDetailView = function ItemDetailView(_ref) {
  var dictionary = _ref.dictionary,
    fileType = _ref.fileType,
    isFAQ = _ref.isFAQ,
    onClose = _ref.onClose,
    selectedItem = _ref.selectedItem,
    selectedFilters = _ref.selectedFilters;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showErrorMsg = _useState2[0],
    setShowErrorMsg = _useState2[1];
  var videoContainerRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    setShowErrorMsg(!!window.CookieInformation && !window.CookieInformation.getConsentGivenFor("cookie_cat_marketing"));
    var observerTargetNode = document.getElementById("coiOverlay");
    var observerConfig = {
      attributes: true,
      attributeFilter: ["style"]
    };
    var callback = function callback() {
      var shouldShowError = !!window.CookieInformation && !window.CookieInformation.getConsentGivenFor("cookie_cat_marketing");
      setShowErrorMsg(shouldShowError);
    };
    var observer = new MutationObserver(callback);
    if (!!window.CookieInformation) {
      observer.observe(observerTargetNode, observerConfig);
    }
    return function () {
      observer.disconnect();
    };
  }, []);
  useEffect(function () {
    setupErrorMsg(videoContainerRef.current);
  }, [videoContainerRef]);
  var blockClick = function blockClick(e) {
    e.stopPropagation();
  };
  var openItem = function openItem(e) {
    e.preventDefault();
    if (selectedItem.mimeType !== MimeType.EMBED) {
      trackDownloadInResourceCenter(fileType, selectedItem.name, selectedFilters);
      window.open(selectedItem.url, "_blank");
    }
  };
  var iframe = selectedItem.url.replace(/\[/g, "<").replace(/\]/g, ">");
  var defaultContent = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "lightbox-fileimg",
    style: selectedItem.image !== "" ? {
      backgroundImage: "url(".concat(selectedItem.image, ")")
    } : {
      display: "none"
    },
    onClick: function onClick(e) {
      return openItem(e);
    },
    onKeyUp: function onKeyUp(e) {
      return e.key === "Enter" && openItem(e);
    },
    role: "button",
    tabIndex: "0"
  }), !isFAQ && /*#__PURE__*/React.createElement("h4", {
    className: "lightbox-filename",
    dangerouslySetInnerHTML: {
      __html: selectedItem.name
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "lightbox-filedescription",
    dangerouslySetInnerHTML: {
      __html: selectedItem.text
    }
  }), /*#__PURE__*/React.createElement("a", {
    className: "lightbox-download",
    href: selectedItem.mimeType === MimeType.EMBED ? "" : selectedItem.url,
    rel: "noopener noreferrer",
    target: "_blank",
    title: selectedItem.mimeType === MimeType.EMBED ? selectedItem.url : selectedItem.name,
    onClick: function onClick(e) {
      return openItem(e);
    }
  }, selectedItem.mimeType === MimeType.EMBED ? dictionary.embed : dictionary.download));
  var videoContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "video-container",
    dangerouslySetInnerHTML: {
      __html: iframe
    }
  }), /*#__PURE__*/React.createElement(Loader, null));
  var errorContent = /*#__PURE__*/React.createElement("div", {
    className: "video-container__error"
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-container__error__container",
    ref: videoContainerRef
  }));
  var content = selectedItem.mimeType === MimeType.EMBED ? showErrorMsg ? errorContent : videoContent : defaultContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "detail-lightbox outer-container ".concat(fileType),
    onClick: onClose,
    onKeyUp: function onKeyUp(e) {
      return e.key === "Enter" && onClose;
    },
    role: "button",
    tabIndex: "-20",
    id: "detail-".concat(selectedItem.id)
  }, /*#__PURE__*/React.createElement("button", {
    className: "lightbox-close",
    "aria-label": "close",
    onClick: onClose,
    onKeyUp: function onKeyUp(e) {
      return e.key === "Enter" && onClose;
    }
  }, "\uE20F"), /*#__PURE__*/React.createElement("div", {
    className: "inner-container",
    onClick: function onClick(e) {
      return blockClick(e);
    },
    onKeyUp: function onKeyUp(e) {
      return blockClick(e);
    },
    role: "button",
    tabIndex: "-10"
  }, content));
};
ItemDetailView.propTypes = {
  dictionary: DefaultPropTypes.dictionary.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedItem: DefaultPropTypes.item.isRequired
};
export default ItemDetailView;